// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import WebOperationEquipmentModel from '../../model/web-operation-equipment-model';
import WebOperationEquipmentDTO from '../dto/web-operation-equipment-dto';
import dtoSchema from '../schemas/web-operation-equipment-schema';

export default abstract class WebOperationEquipmentModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<WebOperationEquipmentDTO>) {
    super();
    if (data) {
      this.name = data.name ?? undefined;
    }
  }
  /**
  */
  name?: string;

  static toModel(dto: DeepPartial<WebOperationEquipmentDTO>): WebOperationEquipmentModel;
  static toModel(dto: DeepPartial<WebOperationEquipmentDTO> | undefined | null): WebOperationEquipmentModel | undefined;
  static toModel(dto: DeepPartial<WebOperationEquipmentDTO> | undefined | null): WebOperationEquipmentModel | undefined {
    return dto ? new WebOperationEquipmentModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<WebOperationEquipmentModel> | WebOperationEquipmentModel): WebOperationEquipmentDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      name: unwrapped.name,
    } as WebOperationEquipmentDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for WebOperationEquipmentModel, can not map to WebOperationEquipmentDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
